import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("flotta_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("flotta_token", token);
  else localStorage.removeItem("flotta_token");
}

export function apiError(detail) {
  if (detail == null) return "Si e' verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Apre il checkout Stripe in modo compatibile con l'anteprima (iframe): Stripe rifiuta di
// caricarsi dentro un iframe, quindi in anteprima apriamo una nuova scheda a livello top.
export function openCheckout(url) {
  if (!url) return;
  let framed = false;
  try { framed = window.self !== window.top; } catch { framed = true; }
  if (framed) {
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (w) return;
    try { window.top.location.href = url; return; } catch { /* iframe sandboxed */ }
  }
  window.location.href = url;
}

export default api;
